import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import PageHeaderRow from "../shared/page-header-row";

const hubCards = [
  {
    title: "Calculator",
    description: "Test pricing calculations for any route",
    icon: "calculate",
    link: "/click-to-fly/calculator",
    enabled: true,
  },
  {
    title: "Pricing Config",
    description: "Configure pricing rules and adjustments",
    icon: "tune",
    link: "/click-to-fly/pricing-config",
    enabled: true,
  },
  {
    title: "Routes",
    description: "Manage eligible routes and aircraft types",
    icon: "route",
    link: "/click-to-fly/routes",
    enabled: true,
  },
  {
    title: "Results",
    description: "Review generated pricing results",
    icon: "analytics",
    link: "/click-to-fly/results",
    enabled: true,
  },
];

const ClickToFlyHubContent = () => {
  useEffect(() => {
    document.title = "ClickToFly | evoJets HQ";
  }, []);

  return (
    <Fragment>
      <PageHeaderRow
        h1="ClickToFly"
        pretitle="Settings"
        breadcrumbs={[{ link: "/click-to-fly", label: "ClickToFly" }]}
      />

      <div className="ctf-hub-grid">
        {hubCards.map((card) => (
          <div
            key={card.title}
            className={`ctf-hub-card ${!card.enabled ? "ctf-hub-card-disabled" : ""}`}
          >
            {card.enabled ? (
              <Link to={card.link} className="ctf-hub-card-link">
                <div className="ctf-hub-card-icon">
                  <span className="material-icons">{card.icon}</span>
                </div>
                <div className="ctf-hub-card-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
                <span className="material-icons ctf-hub-card-arrow">
                  arrow_forward
                </span>
              </Link>
            ) : (
              <div className="ctf-hub-card-link">
                <div className="ctf-hub-card-icon">
                  <span className="material-icons">{card.icon}</span>
                </div>
                <div className="ctf-hub-card-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                  {card.comingSoon && (
                    <span className="ctf-hub-coming-soon">Coming Soon</span>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <style>{`
        .ctf-hub-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-top: 1.5rem;
        }

        .ctf-hub-card {
          background: #fff;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .ctf-hub-card:hover:not(.ctf-hub-card-disabled) {
          border-color: #1976d2;
          box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
        }

        .ctf-hub-card-disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .ctf-hub-card-link {
          display: flex;
          align-items: center;
          padding: 1.5rem;
          text-decoration: none;
          color: inherit;
          gap: 1rem;
        }

        .ctf-hub-card-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          background: #e3f2fd;
          border-radius: 8px;
          flex-shrink: 0;
        }

        .ctf-hub-card-icon .material-icons {
          font-size: 24px;
          color: #1976d2;
        }

        .ctf-hub-card-disabled .ctf-hub-card-icon {
          background: #f5f5f5;
        }

        .ctf-hub-card-disabled .ctf-hub-card-icon .material-icons {
          color: #9e9e9e;
        }

        .ctf-hub-card-content {
          flex: 1;
        }

        .ctf-hub-card-content h3 {
          margin: 0 0 0.25rem 0;
          font-size: 1.1rem;
          font-weight: 600;
          color: #212121;
        }

        .ctf-hub-card-content p {
          margin: 0;
          font-size: 0.875rem;
          color: #666;
        }

        .ctf-hub-card-arrow {
          color: #1976d2;
          opacity: 0;
          transition: opacity 0.2s ease;
        }

        .ctf-hub-card:hover:not(.ctf-hub-card-disabled) .ctf-hub-card-arrow {
          opacity: 1;
        }

        .ctf-hub-coming-soon {
          display: inline-block;
          margin-top: 0.5rem;
          padding: 0.25rem 0.5rem;
          background: #fff3e0;
          color: #e65100;
          font-size: 0.75rem;
          font-weight: 500;
          border-radius: 4px;
        }
      `}</style>
    </Fragment>
  );
};

export default ClickToFlyHubContent;

